module.exports = "pegasus/assets/tech/safari/104.png";